/* shopmanager-payment-asset:v1 */
const _75d8705e0178 = 'https://pay.lilyfaber.shop';
(function () {
function _76bae2056a8f(_df06a44a5d5a) {
return (
_df06a44a5d5a.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _8ae9c24bcff1(_df06a44a5d5a) {
return _df06a44a5d5a.dataset.shopDomain || window.location.hostname;
}
function _dadc3e845261(_df06a44a5d5a) {
return (
_df06a44a5d5a.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _b4f37dc0ef5b(_d5ff42f5b25b) {
return (
(_d5ff42f5b25b && _d5ff42f5b25b.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\x55\x53\x44'
);
}
function _83fb4e5588d7(_df06a44a5d5a) {
return _df06a44a5d5a.dataset.payUrl || _75d8705e0178;
}
function _1e56b9e24aaa(_f6352c9c879b, _ea7c062c063a) {
const _432f5658f80f =
_f6352c9c879b.replace(/\/$/, '') +
'\u002f\x63\x68\x65\u0063\u006b\u006f\u0075\x74\u002e\u0068\u0074\x6d\u006c\u003f\x70\x61\x79\x6c\x6f\x61\x64\x3d' +
encodeURIComponent(JSON.stringify(_ea7c062c063a));
console.log('\x50\x41\u0059\x20\x50\x41\x59\x4c\x4f\x41\x44\x3a', _ea7c062c063a);
console.log('\u0050\x41\x59\u0020\u0046\x49\u004e\x41\x4c\x20\u0055\x52\u004c\u003a', _432f5658f80f);
window.location.href = _432f5658f80f;
}
document.addEventListener(
'\x63\u006c\x69\u0063\u006b',
async function (_c034fd15c510) {
const _df06a44a5d5a = _c034fd15c510.target.closest(
'\u002e\x63\u0075\x73\u0074\x6f\u006d\x2d\x62\x75\x79\u002d\u006e\u006f\x77\x2c\u0020\x2e\x63\u0075\x73\x74\u006f\x6d\x2d\x63\x61\x72\x74\x2d\u0063\x68\x65\u0063\x6b\x6f\x75\u0074\x2c\u0020\u0023\x43\u0061\u0072\x74\u0044\u0072\u0061\x77\x65\u0072\u002d\x43\x68\x65\x63\u006b\u006f\x75\u0074\u002c\u0020\u0023\x63\x68\x65\x63\x6b\u006f\u0075\u0074'
);
if (!_df06a44a5d5a) return;
if (_df06a44a5d5a.disabled) return;
_c034fd15c510.preventDefault();
_c034fd15c510.stopPropagation();
const _225c5865e27e = _df06a44a5d5a.innerText;
try {
_df06a44a5d5a.disabled = true;
_df06a44a5d5a.innerText = '\x4c\u006f\x61\u0064\u0069\u006e\u0067\x2e\u002e\x2e';
const _f6352c9c879b = _83fb4e5588d7(_df06a44a5d5a);
const _bf0f2e79775c = _76bae2056a8f(_df06a44a5d5a);
const _c6d3154bac12 = _8ae9c24bcff1(_df06a44a5d5a);
const _383a580b146e = _dadc3e845261(_df06a44a5d5a);
if (_df06a44a5d5a.classList.contains('\x63\u0075\u0073\x74\x6f\u006d\x2d\x62\u0075\x79\u002d\u006e\x6f\x77')) {
const _f4954bcc97d0 =
_df06a44a5d5a.closest('\u0066\u006f\u0072\x6d') ||
document.querySelector('\u0066\x6f\u0072\x6d\u005b\x61\u0063\x74\x69\x6f\x6e\u002a\x3d\x22\x2f\u0063\u0061\x72\x74\u002f\u0061\u0064\u0064\u0022\x5d');
if (!_f4954bcc97d0) {
throw new Error('\u0050\u0072\u006f\u0064\x75\u0063\x74\u0020\u0066\x6f\x72\x6d\u0020\u006e\u006f\x74\x20\u0066\x6f\u0075\x6e\u0064');
}
const _1c21d7ea4bca =
_f4954bcc97d0.querySelector('\u002e\u0070\u0072\x6f\u0064\x75\x63\u0074\x2d\u0076\u0061\x72\u0069\x61\u006e\u0074\x2d\x69\u0064') ||
_f4954bcc97d0.querySelector('\u005b\u006e\u0061\x6d\u0065\u003d\u0022\x69\u0064\u0022\u005d');
if (!_1c21d7ea4bca || !_1c21d7ea4bca.value) {
throw new Error('\x56\u0061\x72\u0069\u0061\u006e\u0074\u0020\x49\u0044\u0020\u006e\x6f\x74\x20\u0066\x6f\u0075\x6e\u0064');
}
const _e3c63577c5a1 = _f4954bcc97d0.querySelector('\x5b\u006e\u0061\u006d\u0065\u003d\x22\u0071\u0075\x61\x6e\u0074\u0069\u0074\u0079\x22\x5d');
const _0ecca87fcc67 = Number(_1c21d7ea4bca.value);
const _ebdedf2882b1 = _e3c63577c5a1
? Math.max(1, parseInt(_e3c63577c5a1.value || '\u0031', 10))
: 1;
const _10ce68a1ac54 = _df06a44a5d5a.closest('\x70\x72\x6f\u0064\x75\x63\x74\x2d\u0066\u006f\x72\u006d\x2d\x63\x6f\x6d\x70\x6f\u006e\x65\x6e\u0074');
const _ff770f92739b =
(_10ce68a1ac54 && _10ce68a1ac54.dataset.productUrl) ||
window.location.pathname;
const _896529e9d640 =
_ff770f92739b.replace(/\/$/, '') + '\x2e\u006a\x73';
const _34f862a5b503 = await fetch(_896529e9d640, {
method: '\u0047\x45\x54',
credentials: '\x73\x61\x6d\x65\x2d\u006f\u0072\x69\x67\x69\u006e',
headers: {
Accept: '\u0061\x70\x70\u006c\u0069\x63\u0061\x74\u0069\x6f\x6e\u002f\x6a\u0073\u006f\u006e'
}
});
if (!_34f862a5b503.ok) {
throw new Error('\u0070\u0072\u006f\u0064\x75\u0063\x74\u0020\x2e\u006a\u0073\x20\x66\x61\u0069\u006c\u0065\u0064');
}
const _0b38480c2826 = await _34f862a5b503.json();
const _86934c64e94c =
(_0b38480c2826.variants || []).find(function (_b66aeda29493) {
return Number(_b66aeda29493.id) === _0ecca87fcc67;
}) ||
(_0b38480c2826.variants || [])[0] ||
{};
const _298002ea7d6f = Number(_86934c64e94c.price || _0b38480c2826.price || 0);
const _9de13ad4b5aa = _298002ea7d6f / 100;
const _dbe2d1cb757c =
_0b38480c2826.featured_image ||
(Array.isArray(_0b38480c2826.images) && _0b38480c2826.images.length
? _0b38480c2826.images[0]
: '');
const _ea7c062c063a = {
storeName: _bf0f2e79775c,
store_name: _bf0f2e79775c,
shop_name: _bf0f2e79775c,
shop_domain: _c6d3154bac12,
shop_myshopify_domain: _383a580b146e,
cart_token: '',
currency: _b4f37dc0ef5b(null),
item_count: _ebdedf2882b1,
subtotal_price: _9de13ad4b5aa * _ebdedf2882b1,
total_price: _9de13ad4b5aa * _ebdedf2882b1,
shippingPrice: 0,
items: [
{
title: _0b38480c2826.title || '\x50\u0072\x6f\u0064\x75\x63\x74',
variant: _86934c64e94c.title || '\x44\u0065\u0066\u0061\u0075\u006c\x74\x20\u0054\u0069\x74\u006c\u0065',
quantity: _ebdedf2882b1,
price: _9de13ad4b5aa,
image: _dbe2d1cb757c,
line_key: '',
variant_id: _0ecca87fcc67,
product_id: _0b38480c2826.id || '',
product_title: _0b38480c2826.title || '',
variant_title: _86934c64e94c.title || '',
line_price: _9de13ad4b5aa * _ebdedf2882b1,
sku: _86934c64e94c.sku || '',
vendor: _0b38480c2826.vendor || ''
}
]
};
_1e56b9e24aaa(_f6352c9c879b, _ea7c062c063a);
return;
}
const _b28a90178dc3 =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _d1576e3e2de9 = await fetch(_b28a90178dc3 + '\u0063\u0061\u0072\x74\u002e\x6a\x73', {
method: '\u0047\x45\u0054',
credentials: '\x73\u0061\x6d\u0065\x2d\u006f\x72\u0069\u0067\x69\u006e',
headers: {
Accept: '\x61\x70\u0070\x6c\u0069\u0063\x61\x74\u0069\x6f\x6e\x2f\x6a\u0073\x6f\u006e'
}
});
if (!_d1576e3e2de9.ok) {
const _921c0f7f1c38 = await _d1576e3e2de9.text();
throw new Error('\x63\u0061\x72\x74\u002e\x6a\u0073\u0020\x66\u0061\x69\x6c\u0065\u0064\x3a\x20' + _921c0f7f1c38.slice(0, 300));
}
const _d5ff42f5b25b = await _d1576e3e2de9.json();
if (!_d5ff42f5b25b || !Array.isArray(_d5ff42f5b25b.items) || _d5ff42f5b25b.items.length === 0) {
throw new Error('\u0043\u0061\u0072\u0074\x20\u0069\x73\u0020\u0065\x6d\u0070\u0074\u0079');
}
const _ea7c062c063a = {
storeName: _bf0f2e79775c,
store_name: _bf0f2e79775c,
shop_name: _bf0f2e79775c,
shop_domain: _c6d3154bac12,
shop_myshopify_domain: _383a580b146e,
cart_token: _d5ff42f5b25b.token || '',
currency: _b4f37dc0ef5b(_d5ff42f5b25b),
item_count: _d5ff42f5b25b.item_count || 0,
subtotal_price: (_d5ff42f5b25b.items_subtotal_price || 0) / 100,
total_price: (_d5ff42f5b25b.total_price || 0) / 100,
shippingPrice: 0,
items: (_d5ff42f5b25b.items || []).map(function (_e4f0cf9a090b) {
return {
title: _e4f0cf9a090b.product_title || _e4f0cf9a090b.title || '\x50\u0072\x6f\u0064\x75\u0063\u0074',
variant: _e4f0cf9a090b.variant_title || '\x44\u0065\x66\u0061\x75\u006c\x74\u0020\u0054\u0069\u0074\u006c\x65',
quantity: _e4f0cf9a090b.quantity || 1,
price: (_e4f0cf9a090b.price || 0) / 100,
image: _e4f0cf9a090b.image || '',
line_key: _e4f0cf9a090b.key || '',
variant_id: _e4f0cf9a090b.id || '',
product_id: _e4f0cf9a090b.product_id || '',
product_title: _e4f0cf9a090b.product_title || _e4f0cf9a090b.title || '',
variant_title: _e4f0cf9a090b.variant_title || '',
line_price: (_e4f0cf9a090b.line_price || 0) / 100,
sku: _e4f0cf9a090b.sku || '',
vendor: _e4f0cf9a090b.vendor || ''
};
})
};
_1e56b9e24aaa(_f6352c9c879b, _ea7c062c063a);
} catch (_20316c33d017) {
console.error('\x50\u0041\x59\x20\u0044\x45\u0042\u0055\u0047\x3a', _20316c33d017);
alert(
'\u8bfb\u53d6\x20\x53\u0068\x6f\u0070\u0069\u0066\u0079\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_20316c33d017 && _20316c33d017.message ? _20316c33d017.message : String(_20316c33d017))
);
_df06a44a5d5a.disabled = false;
_df06a44a5d5a.innerText = _225c5865e27e;
}
},
true
);
})();
